export default "__VITE_ASSET__BQ0QhZ6O__"